import { createAction } from 'redux-actions';
import type { EditorState } from '../components/Editor/types';

export const saveEditorDraft = createAction(
  'DA_EDITOR.SAVE_EDITOR_DRAFT',
  (editorId: string, editorState: EditorState) => ({
    editorId,
    editorState,
  })
);

export const removeEditorDraft = createAction(
  'DA_EDITOR.REMOVE_EDITOR_DRAFT',
  (editorId: string) => ({ editorId })
);
